export default {
      id: "set-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "static/img/icons.d90c56e0.svg#set",
      toString: function () {
        return this.url;
      }
    }